import { render } from "./MyLittleLibrary.vue?vue&type=template&id=6584c4e2&scoped=true"
import script from "./MyLittleLibrary.vue?vue&type=script&lang=js"
export * from "./MyLittleLibrary.vue?vue&type=script&lang=js"

import "./MyLittleLibrary.vue?vue&type=style&index=0&id=6584c4e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6584c4e2"]])

export default __exports__